export * from './icon.component';
export * from './icon.factory';
export * from './icon.model';
export * from './icon.styles';
export * from './icon.types';
